import { LoggerProvider, BatchLogRecordProcessor, ConsoleLogRecordExporter, SimpleLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { logs, SeverityNumber } from '@opentelemetry/api-logs';
import { UIX_CONFIG, BACKEND_CONFIG } from '../config';
import { telemetry, TelemetryEvent, ITelemetryProvider } from '@shared/services/telemetry';
import { LogLevel } from '@shared/services/logger';

class OtelProvider implements ITelemetryProvider {
    private otelLogger = logs.getLogger('constantina-uix');

    public track(event: TelemetryEvent, properties: Record<string, any>, userId?: string) {
        this.otelLogger.emit({
            severityNumber: SeverityNumber.INFO,
            severityText: 'TELEMETRY',
            body: `Event: ${event}`,
            attributes: {
                event: event,
                userId: userId || 'anonymous',
                ...properties
            }
        });
    }

    public flush() {
        // Otel handles flushing via BatchLogRecordProcessor
    }
}

export const initUIXTelemetry = () => {
    try {
        const resource = new Resource({
            [ATTR_SERVICE_NAME]: UIX_CONFIG.SERVICE_NAME,
            [ATTR_SERVICE_VERSION]: UIX_CONFIG.SERVICE_VERSION,
        });

        const loggerProvider = new LoggerProvider({ resource });
        
        // Console
        loggerProvider.addLogRecordProcessor(new SimpleLogRecordProcessor(new ConsoleLogRecordExporter()));

        // OTLP
        const otlpEndpoint = (import.meta as any).env?.VITE_OTEL_EXPORTER_OTLP_LOGS_ENDPOINT || 'http://localhost:4318/v1/logs';
        const isLocalLocalhost = otlpEndpoint.includes('localhost') || otlpEndpoint.includes('127.0.0.1');

        // Only enable OTLP if external backend is used OR if it's a non-localhost endpoint
        if (BACKEND_CONFIG.USE_EXTERNAL_BACKEND || !isLocalLocalhost) {
            const otlpExporter = new OTLPLogExporter({
                url: otlpEndpoint
            });
            loggerProvider.addLogRecordProcessor(new BatchLogRecordProcessor(otlpExporter));
            console.log(`[Telemetry] OTLP Log Exporter enabled for endpoint: ${otlpEndpoint}`);
        } else {
            console.log(`[Telemetry] OTLP Log Exporter skipped (Local development without remote collector)`);
        }

        logs.setGlobalLoggerProvider(loggerProvider);

        // Register with Shared Telemetry
        const provider = new OtelProvider();
        telemetry.registerProvider(provider);

        // Also set global _OTEL_LOGGER for the Shared BaseLogger to pick up
        (globalThis as any)._OTEL_LOGGER = logs.getLogger(UIX_CONFIG.SERVICE_NAME);

        console.log(`[Telemetry] UIX OpenTelemetry provider registered.`);
    } catch (error) {
        console.warn('[Telemetry] UIX OpenTelemetry initialization failed:', error);
    }
};
